import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";

const APPS_SEARCH_BASE_KEY = "apps-search";

const TABLE_DATA_QUERY_KEY = "table-data";
const COLUMN_CONFIG_QUERY_KEY = "column-config";
const COLUMN_SELECTION_MUTATION_KEY = "column-selection-mutation";

export const appsSearchQueryKeys = {
    all() {
        return [APPS_SEARCH_BASE_KEY] as const;
    },

    tableData() {
        return [...appsSearchQueryKeys.all(), TABLE_DATA_QUERY_KEY] as const;
    },

    columnConfig(appOs?: AppOperatingSystem) {
        const base = [...appsSearchQueryKeys.all(), COLUMN_CONFIG_QUERY_KEY] as const;
        return appOs ? ([...base, appOs] as const) : base;
    },

    columnSelectionMutation() {
        return [...appsSearchQueryKeys.all(), COLUMN_SELECTION_MUTATION_KEY];
    },
} as const;
